import {
  EmployeesSettingFragment,
  FetchEmployeesSettingsDocument,
  FetchEmployeesSettingsQuery,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

type Props = {
  startOn?: string
  endOn?: string
  companyIds?: string[]
  employeeIds?: string[]
  ids?: string[]
}

export type EmployeesSettingsQuery =
  FetchEmployeesSettingsQuery['attendance']['employeesSettingsConnection']['nodes']

export const useFetchEmployeesSettings = ({
  startOn,
  endOn,
  companyIds,
  employeeIds,
  ids,
}: Props) => {
  const { loading, data } = useQuery(FetchEmployeesSettingsDocument, {
    variables: { startOn, endOn, companyIds, employeeIds, ids },
    fetchPolicy: 'cache-first',
  })

  const employeesSettings = data?.attendance.employeesSettingsConnection.nodes
    ? data?.attendance.employeesSettingsConnection.nodes
    : []

  return {
    loading,
    employeesSettings: employeesSettings.map(
      (employeesSetting) => new EmployeesSetting(employeesSetting)
    ),
  }
}

export class EmployeesSetting {
  employeesSetting: EmployeesSettingFragment
  id: string
  policyName: string
  activeEmployeeIds: string[]
  defaultPolicy: boolean | null | undefined
  desktopClockin: boolean
  qrCodeClockin: boolean
  geolocation: boolean
  faceRecognition: boolean
  mobileClockin: boolean
  idClockSharedDevice: boolean

  constructor(employeesSetting: EmployeesSettingFragment) {
    const {
      attendanceEmployeesPolicy: { name: policyName, activeEmployeeIds, default: defaultPolicy },
      desktopClockin,
      qrCodeClockin,
      geolocation,
      faceRecognition,
      mobileClockin,
      idClockSharedDevice,
      id,
    } = employeesSetting

    this.employeesSetting = employeesSetting
    this.id = id
    this.policyName = policyName
    this.activeEmployeeIds = activeEmployeeIds
    this.defaultPolicy = defaultPolicy
    this.desktopClockin = desktopClockin
    this.qrCodeClockin = qrCodeClockin
    this.geolocation = geolocation
    this.faceRecognition = faceRecognition
    this.mobileClockin = mobileClockin
    this.idClockSharedDevice = idClockSharedDevice
  }

  get timeoffCompensationEnabled(): boolean {
    return this.employeesSetting.timeoffCompensation
  }

  get payrollCompensationEnabled(): boolean {
    return this.employeesSetting.payrollCompensation
  }

  get withCompensationEnabled(): boolean {
    return this.timeoffCompensationEnabled || this.payrollCompensationEnabled
  }

  get hasFlagsEnabled(): boolean {
    return (
      this.mobileClockin ||
      this.desktopClockin ||
      this.qrCodeClockin ||
      this.geolocation ||
      this.faceRecognition ||
      this.idClockSharedDevice
    )
  }
}
